import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowShareLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-share-left, back, last, reply"} maskId="square-filled-radius-0-stroke-1-IconArrowShareLeft"><path d="M12.0005 8.00426V2.41895L0.728516 12.0002L12.0005 21.5814V16.0026C15.9121 16.0409 18.0491 16.5344 19.3736 17.3071C20.7286 18.0975 21.2974 19.212 22.0533 20.7238L23.0005 20.5002C23.0005 16.23 22.3794 13.0674 20.5651 10.9843C18.8062 8.96479 16.0288 8.07129 12.0005 8.00426Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowShareLeft;
